var path = '/app/pages/main/main.page.html';
var html = "<container class=wrapper></container>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/main/main.page.html
// module id = 315
// module chunks = 0